import {
  PostTen99PolicyContractingEntityBodySchema,
  PostTen99PolicyContractingEntityResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation } from "@tanstack/react-query";
import { type z } from "zod";

type CreateTen99PolicyEntityBody = z.infer<typeof PostTen99PolicyContractingEntityBodySchema>;

interface CreateTen99PolicyEntityParams {
  workplaceId: string;
  categoryCode: string;
}

export function useCreateTen99PolicyEntity() {
  return useMutation({
    mutationFn: async ({ workplaceId, categoryCode }: CreateTen99PolicyEntityParams) => {
      const body: CreateTen99PolicyEntityBody = {
        data: {
          type: "ten99-policy-entity",
          attributes: {
            categoryCode,
          },
          relationships: {
            workplace: {
              data: {
                type: "workplace",
                id: workplaceId,
              },
            },
          },
        },
      };

      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}/1099-policy/entities`,
        data: body,
        bodySchema: PostTen99PolicyContractingEntityBodySchema,
        responseSchema: PostTen99PolicyContractingEntityResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_TEN99_POLICY_ENTITY_FAILURE,
    },
  });
}
